import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import ReactDatePicker from 'react-datepicker';
import type { ReactDatePickerProps } from 'react-datepicker';
import { DatepickerWrapper } from './Datepicker.styled';
import { DATEPICKER_WRAPPER } from '../../util/data-id';

interface Props extends ReactDatePickerProps {
  startDate?: Date | null;
}

const DatePicker = ({ startDate, ...other }: Props): JSX.Element => {

  const { locale } = useI18n();

  return (
    <DatepickerWrapper data-id={DATEPICKER_WRAPPER}>
      <ReactDatePicker
        selected={startDate}
        locale={locale?.id}
        {...other as ReactDatePickerProps}
      />
    </DatepickerWrapper>
  );
};

DatePicker.displayName = 'DatePicker';

export default DatePicker;
